import { FundsSelection } from '@components/fundsSelection';
import { Widget } from '@widgets/widget';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  FundsSelection,
  Widget,
};
